import React, { FC } from 'react';
import { BaseLevels, Tabs, Text } from '@kb-front/ui-kit';
import { IProductData } from 'shared/model';
import { translate } from 'shared/utils/translation';

import Conditions from 'components/Conditions';
import Faq from 'components/Faq';

import './index.scss';

interface IProps {
  productData?: IProductData;
}

const InfoTabs: FC<IProps> = ({ productData }) => {
  const additionalInfos = [
    {
      id: 'info-tab-faq',
      content: <Faq />,
      value: 'faqData',
      label: <h2>{translate('usefulToKnow.oftenQuestions')}</h2>,
    },
    {
      id: 'info-tab-conditions',
      content: <Conditions productData={productData} />,
      value: 'conditions',
      label: <h2>{translate('usefulToKnow.conditions')}</h2>,
    },
    {
      id: 'info-tab-additional-info',
      content: <Text>{translate('usefulToKnow.additionalInfoText')}</Text>,
      value: 'additionalInfo',
      label: (
        <h2>
          <Text level={BaseLevels.L2}>{translate('usefulToKnow.additioanlInfo')}</Text>
        </h2>
      ),
    },
  ];

  return (
    <div className="info__tabs">
      <Tabs items={additionalInfos} />
    </div>
  );
};

export default InfoTabs;
